import React, { useState } from 'react';
// import Logo from '../../assets/images/Yogify.png';
import { GiPrayerBeads } from 'react-icons/gi'; 
import { RiTruckLine, RiSecurePaymentLine } from 'react-icons/ri';
import { FcGoogle } from "react-icons/fc";
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { toast } from 'react-hot-toast';
import apiClient from '../../services/apiClient';
import { useDispatch } from 'react-redux';

import { useNavigate } from 'react-router-dom';
import { setUser } from '../../features/auth/authSlice';
import { useGoogleLogin } from "@react-oauth/google";
import LoginBanner from '../../assets/images/login.jpg'
const Login = () => {
  const [showPassword, setShowPassword] = useState(false);  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState("");
  const [passError, setPassError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  

  const handleGoogleLogin = async (tokenResponse) => {
    try {
      setIsLoading(true);
      const accessToken = tokenResponse.access_token;

      // Fetch user info from Google API
      const userInfoRes = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const userInfo = await userInfoRes.json();

      const payload = {
        email: userInfo.email,
        name: userInfo.name,
        google_id: userInfo.sub,
      };

      const res = await apiClient.post("/login/google", payload);
      dispatch(setUser(res.data));
      toast.success("Google sign-in successful!");
      navigate('/'); // Redirect to home after login
    } catch (err) {
      console.error(err);
      toast.error("Google login failed");
    } finally {
      setIsLoading(false);
    }
  };

  const login = useGoogleLogin({
    onSuccess: handleGoogleLogin,
    onError: () => toast.error("Google login failed"),
  });

    

  const handleCustomGoogleLogin = () => {
    login(); 
  };
 
  const handleLogin = async () => {
    try {
      setIsLoading(true);
      const res = await apiClient.post('/login', {
        email,
        password,
      });

      if (res.status == 200) {
        console.log(res.data.user);
        dispatch(setUser(res.data));
        toast.success("Login successful!");
      //  navigate('/'); 
      } else {
        toast.error(res.data.message || "Login failed: password or username incorrect");
      }
    } catch (error) {
      // toast.error(error.response.data.message || "Login failed");
      console.error(error);
      if (error.response) {
        const message = error.response.data.message || "Login failed: password or username incorrect";
        if (message.includes("email")) {
          setEmailError(message);
        } else if (message.includes("password")) {
          setPassError(message);
        } else {
          toast.error(message);
        }
      } else {
        toast.error("Network error. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleValidation = (e) => {
    e.preventDefault();
    let isValid = true;
    const emailRegex = /^\S+@\S+\.\S+$/;

    // Reset errors
    setEmailError("");
    setPassError("");

    // Email validation
    if (!email) {
      setEmailError("Email is required");
      isValid = false;
    } else if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email");
      isValid = false;
    }

    // Password validation
    if (!password) {
      setPassError("Password is required");
      isValid = false;
    } else if (password.trim().length < 8) {
      setPassError("Password must contain at least 8 characters");
      isValid = false;
    }

    if (isValid) {
      handleLogin();
    }
  };

  return (
    <div id='Login'>
      <div className='container'>
        <div className='LoginMain'>
          <div className='LoginBox'>
            <div className='LoginLeftBox'>
              <img src={LoginBanner} alt="" />
              {/* <div className='LoginLogo'>
                <img src={Logo} alt="Yogify Logo" />
              </div>
              <div className='LoginTitle'>
                <h2>Authentic Spiritual Essentials to Help You Connect with Your True Self</h2>
              </div>
              <div className='ProductSecureBox'>
                <div className='SecureBox'>
                  <div className='IconBox'>
                    <GiPrayerBeads className='SecureIcon' />
                  </div>
                  <div className='SecureTitle'>
                    <p>Soulful Accessories</p>
                  </div>
                  <div className='SecureDescription'>
                    <p>Crafted with Trusted Spiritual Quality</p>
                  </div>
                </div>
                
                <div className='SecureBox'>
                  <div className='IconBox'>
                    <RiSecurePaymentLine className='SecureIcon' />
                  </div>
                  <div className='SecureTitle'>
                    <p>Secure Checkout</p>
                  </div>
                  <div className='SecureDescription'>
                    <p>Multiple Payment Options — Fast, Safe & Secure</p>
                  </div>
                </div>
              </div> */}
            </div>
            <div className='LoginRightBox'>
              <div className='Title'>
                <h2>Login</h2>
                <p>Welcome back! Please enter your credentials to access your account.</p>
              </div>
              
              <div className='LoginFormGroup'>
                <form onSubmit={handleValidation}>
                  <div className='FormField'>
                    <label>Enter Email Address</label>
                    <input 
                      type="email" 
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter Email Address"
                      className={emailError ? 'error' : ''}
                    />
                    {emailError && <span className="error-message">{emailError}</span>}
                  </div>
                  
                  <div className='FormField PasswordField'>
                    <label>Enter Password</label>
                    <div className="PasswordInputWrapper">
                      <input 
                        type={showPassword ? "text" : "password"} 
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter your password"
                        className={passError ? 'error' : ''}
                      />
                      <button 
                        type="button" 
                        className="TogglePassword"
                        onClick={togglePasswordVisibility}
                        aria-label={showPassword ? "Hide password" : "Show password"}
                      >
                        {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                      </button>
                    </div>
                    {passError && <span className="error-message">{passError}</span>}
                  </div>
                  
                  <div className='ForgetPassword'>
                    <a href="/auth/forgotpassword">Forgot your password?</a>
                  </div>
                  
                  <div className='LoginBtn'>
                    <button type="submit" disabled={isLoading}>
                      {isLoading ? 'Logging in...' : 'Login'}
                    </button>
                  </div>
                </form>
              </div>
              
              <div className='OrText'>
                <p>Or continue with social account</p>
              </div>
              
              <div className='GoogleBtn'>
                <button onClick={handleCustomGoogleLogin} disabled={isLoading}>
                  <FcGoogle />
                  <p>Sign in with Google</p>
                </button>
              </div>
              
              <div className='DontAccount'>
                <p>Don't have an Account?</p>
                <a href="/auth/signup">Sign Up</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;